import { render, staticRenderFns } from "./registration-confirm.vue?vue&type=template&id=455584f3&scoped=true&"
import script from "./registration-confirm.vue?vue&type=script&lang=js&"
export * from "./registration-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455584f3",
  null
  
)

export default component.exports